import React, { useState } from "react";

import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./Mixing.messages";
import styles from "./Mixing.module.scss";
import { Slide1, Slide2, Slide3, Slide4, Slide5, Slide6 } from "./slides/Slides";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

interface Mixing {
  title: string;
}

export const Mixing: React.FC<Mixing> = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      case 3:
        return <Slide4 />;
      case 4:
        return <Slide5 />;
      case 5:
        return <Slide6 />;
      default:
        return <Slide1 />;
    }
  };

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <div className={styles.slide}>{renderSlide()}</div>
          <div className={styles.switch}>
            <SwitchOption
              onClick={setSelectedOption}
              activeItem={selectedOption}
              items={[
                {
                  name: formatMessage(messages.G2_P4_Tab1_Title),
                },
                {
                  name: formatMessage(messages.G2_P4_Tab2_Title),
                },
                {
                  name: formatMessage(messages.G2_P4_Tab3_Title),
                },
                {
                  name: formatMessage(messages.G2_P4_Tab4_Title),
                },
                {
                  name: formatMessage(messages.G2_P4_Tab5_Title),
                },
                {
                  name: formatMessage(messages.G2_P4_Tab6_Title),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
